import * as google2fa from './google2fa'
import * as googleActivityControls from './googleActivityControls'
import { googleSetAccountData, isAccountDataGathered } from './googleGather'
import * as googleMapsProfilePrivacy from './googleMapsProfilePrivacy'
import * as googlePayments from './googlePayments'
import * as googleProfileInfo from './googleProfileInfo'
import * as googleProfilePhoto from './googleProfilePhoto'
import * as googleSharedEndorsements from './googleSharedEndorsements'
import { GoogleRecommendationKey } from '../../utils/enums'
import {
  RecommendationAutomationRegistryApi,
  RecommendationAutomationRegistry,
} from '../automationMachineInterfaces'
import * as manualRecommendation from '../manualRecommendation'

const REGISTRY: RecommendationAutomationRegistry = {
  [GoogleRecommendationKey.GOOGLE_2FA]: google2fa,
  [GoogleRecommendationKey.GOOGLE_ACTIVITY_CONTROLS]: googleActivityControls,
  [GoogleRecommendationKey.GOOGLE_CONNECTIONS]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        GoogleRecommendationKey.GOOGLE_CONNECTIONS,
      ),
    ],
  },
  [GoogleRecommendationKey.GOOGLE_INACTIVE_ACCOUNT_MANAGER]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        GoogleRecommendationKey.GOOGLE_INACTIVE_ACCOUNT_MANAGER,
      ),
    ],
  },
  [GoogleRecommendationKey.GOOGLE_LOCATION_SHARING]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        GoogleRecommendationKey.GOOGLE_LOCATION_SHARING,
      ),
    ],
  },
  [GoogleRecommendationKey.GOOGLE_PASSWORD]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        GoogleRecommendationKey.GOOGLE_PASSWORD,
      ),
    ],
  },
  [GoogleRecommendationKey.GOOGLE_PAYMENTS]: googlePayments,
  [GoogleRecommendationKey.GOOGLE_PROFILE_INFO]: googleProfileInfo,
  [GoogleRecommendationKey.GOOGLE_RECOVERY_PHONE_EMAIL]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        GoogleRecommendationKey.GOOGLE_RECOVERY_PHONE_EMAIL,
      ),
    ],
  },
  [GoogleRecommendationKey.GOOGLE_SESSIONS]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        GoogleRecommendationKey.GOOGLE_SESSIONS,
      ),
    ],
  },
  [GoogleRecommendationKey.GOOGLE_SHARED_ENDORSEMENTS]:
    googleSharedEndorsements,
  [GoogleRecommendationKey.GOOGLE_REVIEW_MAPS_CONTRIBUTIONS]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        GoogleRecommendationKey.GOOGLE_REVIEW_MAPS_CONTRIBUTIONS,
      ),
    ],
  },
  [GoogleRecommendationKey.GOOGLE_MAPS_PROFILE_PRIVACY]:
    googleMapsProfilePrivacy,
  [GoogleRecommendationKey.GOOGLE_RESULTS_ABOUT_YOU]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        GoogleRecommendationKey.GOOGLE_RESULTS_ABOUT_YOU,
      ),
    ],
  },
  [GoogleRecommendationKey.GOOGLE_PASSKEYS]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        GoogleRecommendationKey.GOOGLE_PASSKEYS,
      ),
    ],
  },
  [GoogleRecommendationKey.GOOGLE_PROFILE_PHOTO]: googleProfilePhoto,
}

export const googleRegistry: RecommendationAutomationRegistryApi = {
  getAccountUsernameGatherStageDefs: () => googleSetAccountData,
  getAdditionalFullGatherStageDefs: () => [],
  getRecommendationAutomationRegistry: () => REGISTRY,
  isAccountDataGathered: (accountData) => isAccountDataGathered(accountData),
}
